import fast1 from "../Images/Rectangle.png";
import fast2 from "../Images/Rectangle2.png";
import fast3 from "../Images/Rectangle3.png";
import gridoff from "../Images/offgrid.png";
import gridon from "../Images/ongrid.png";
import hybrid from "../Images/hybrid.png";
import project1 from "../Images/project1.png";
import project2 from "../Images/project2.png";
import project3 from "../Images/project3.png";
import project4 from "../Images/project4.png";
import ceo from "../Images/ceo.png";
import cto from "../Images/cto.png";
import chief from "../Images/chief.png";
import chief1 from "../Images/chief1.png";
import chief2 from "../Images/chief2.png";
import hr from "../Images/hr.png";

export const Slider = [
  {
    id: 1,
    title: "GREEN",
    title1: "WEND",
    title2: "ENERGY",
    subtitle: "EMPOWERING OUR FUTURE WITH SOLAR ENERGY",    
    img: fast1,
    button: 'HAVE QUERIES'
  },
  {
      id: 3,
      title1: 'MAGIC OF SOLAR ENERGY',
      subtitle: 'WE PROVIDE CLEAN ENERGY, THE SOLAR ENERGY',
      img: fast2,
      button: 'FREE SURVAY'
    },
    {
        id: 2,
        title: "GET YOUR SOLAR SYSTEM TODAY",
        subtitle: "TODAY’S RESOURCE FOR A BRIGHTER TOMORROW",
        img: fast3,
        button: 'GET QUOTE'
  },
];

export const data = [
  {
    img: gridon,
    title: 'On-Grid Solar System',
    desc: 'It will provide the power to the house and to the grid but no backup will be present. Click here for the offers. You can also customize your plain accourding to your need.',
    learn: 'Learn more',
  },
  
  {
    img: gridon,
    title: 'Off-Grid Solar System',
    desc: 'It will only provide the power to the house and will also charge your batteries for backup. Pre-Tailored packeges accourding to your need are present but you can also customize them.',
    learn: 'Learn more',
  },

  {
    img: gridon,
    title: 'Hybrid Solar System',
    desc: 'This system will provide the power for your house and also charge battries for backup as well as the extra energy will be exported to the grid. Click here for more details and offers.',
    learn: 'Learn more',
  },

] 

export const projects = [
  {
    img: project1,
    title: 'Installed 10kw system at Mr. Atif residency',
    learn: 'Learn more',
  },
  {
    img: project2,
    title: 'Complete setup of hybrid system at TriTech Solutions',
    learn: 'Learn more',
  },
  {
    img: project3,
    title: 'Installed 05kw system at Mr. Nasir farm house',
    learn: 'Learn more',
  },

  {
    img: project4,
    title: 'On-Grid System installed at Deans Residencia appartements',
    learn: 'Learn more',
  },

] 

export const team = [
  {
    img: ceo,
    title: 'Mr. Zeeshan Syed',
    position: 'CEO- Co-Founder',
  },
  {
    img: cto,
    title: 'Mr. Saad Rashid',
    position: 'CTO- Co-Founder',
  },
  {
    img: chief,
    title: 'Miss Maliha Khan',
    position: 'Chief Marketing officer',
  },
  {
    img: hr,
    title: 'Mrs. Kainat Ahmad',
    position: 'Project Manager',
  },
  {
    img: chief1,
    title: 'Mr. Mudassir Ahmad',
    position: 'Chief Design Officer',
  },
  {
    img: chief2,
    title: 'Miss Hamna Irshad',
    position: 'Chief Financial Officer',
  },
]
